import { AgeRangeBounds, UserGeo } from '../types';

export type AgeRangeClassification = 'under_13' | 'age_13_plus' | 'ambiguous' | 'invalid';

const normalizeJurisdictionPart = (value: unknown): string | null => {
  if (typeof value !== 'string') {
    return null;
  }

  const normalized = value.trim().toUpperCase();
  return normalized.length > 0 ? normalized : null;
};

export const isTexasJurisdiction = (geo: UserGeo | null | undefined): boolean => {
  return (
    normalizeJurisdictionPart(geo?.country) === 'US' &&
    normalizeJurisdictionPart(geo?.state) === 'TX'
  );
};

export const hasCompleteJurisdiction = (geo: UserGeo | null | undefined): boolean => {
  return Boolean(normalizeJurisdictionPart(geo?.country) && normalizeJurisdictionPart(geo?.state));
};

const isUsableBound = (value: unknown): value is number => {
  return typeof value === 'number' && Number.isFinite(value) && value >= 0;
};

const isProvided = (value: unknown): boolean => value !== null && value !== undefined;

export const classifyAgeRange = (
  range: AgeRangeBounds | null | undefined
): AgeRangeClassification => {
  if (isUsableBound(range?.upperBound) && range.upperBound < 13) {
    return 'under_13';
  }

  if (isUsableBound(range?.lowerBound) && range.lowerBound >= 13) {
    return 'age_13_plus';
  }

  if (
    (isProvided(range?.lowerBound) && !isUsableBound(range?.lowerBound)) ||
    (isProvided(range?.upperBound) && !isUsableBound(range?.upperBound))
  ) {
    return 'invalid';
  }

  return 'ambiguous';
};

export const isExplicitlyUnder13 = (range: AgeRangeBounds | null | undefined): boolean => {
  return classifyAgeRange(range) === 'under_13';
};
